"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_INPUT_LIMITS = void 0;
exports.CHAT_INPUT_LIMITS = {
    maxMessageLength: 500,
    showNumCharactersTypedLength: 400,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hhdFVJLmNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9DaGF0VUkuY29uc3RhbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGlCQUFpQixHQUFHO0lBQy9CLGdCQUFnQixFQUFFLEdBQUc7SUFDckIsNEJBQTRCLEVBQUUsR0FBRztDQUNsQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IENIQVRfSU5QVVRfTElNSVRTID0ge1xuICBtYXhNZXNzYWdlTGVuZ3RoOiA1MDAsXG4gIHNob3dOdW1DaGFyYWN0ZXJzVHlwZWRMZW5ndGg6IDQwMCxcbn07XG4iXX0=